import { atom } from 'jotai';
import { selectAtom, atomWithReset } from 'jotai/utils';
import { Order, OrderStatus } from '../types/common';
import { PaymentStatus } from '../types/payment';
import { getPickupTimeList } from '../api/legacy';
import { isSSR } from '../utils/helpers';

const initOrderState: Order = {
  ref: '',
  discount: { amount: 0, currency: 'HKD', minor: 2 },
  finalTotal: { amount: 0, currency: 'HKD', minor: 2 },
  paymentStatus: PaymentStatus.WAITING,
  shipments: [],
  status: OrderStatus.ORDER_PENDING,
  invoice: null,
  coupon: null,
  naturalAmount: {
    finalTotal: 0,
  },
};

export const orderAtom = atomWithReset<Order>(initOrderState);

export const orderIdAtom = selectAtom(orderAtom, (order) => order.ref);

export const orderCollectMethodAtom = selectAtom(orderAtom, (order) => order.pickup);

export const pickupTimeListAtom = atom((get) => {
  const orderId = get(orderIdAtom);
  if (isSSR || !orderId) return [];

  return getPickupTimeList(orderId);
});

export default orderAtom;
